import { styled, Box, Card, Typography, Button, RadioGroup, Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";

//Wrapper Styles
export const TWrapper = styled(Box)(({ theme }) => ({
  maxWidth: '428px',
  textAlign: 'center',
  margin: '0 auto',
}));

export const TCard = styled(Card)(({ theme }) => ({
  height: 'auto',
  position: 'relative',
  minHeight: '100vh',
  padding: theme.spacing( 2),
}));

//Header Styles

export const THeaderTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '24px',
  lineHeight: '28px',
  textAlign: 'center',
  fontWeight: 500,
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(3),
}));

//Tips

export const TPaymentTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '22px',
  lineHeight: '28px',
  textAlign: 'left',
  fontWeight: 400,
  paddingBottom: theme.spacing(2),
}));

export const TipTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '16px',
  lineHeight: '20px',
  textAlign: 'left',
  fontWeight: 600,
  // paddingBottom: theme.spacing(3),
}));

export const GridItem = styled(Grid)(({ theme }) => ({
  '.MuiFormControlLabel-root': {
    marginLeft: '-30px',
  },
  [theme.breakpoints.down(700)]: {
    '.MuiFormControlLabel-root': {
      marginLeft: '-11px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    textAlign: 'left'
  }
}));

export const TipWrapBlock = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  gap: '16px',
}));

export const TipBlock = styled(LoadingButton)(({ theme }) => ({
  width: '100%',
  lineHeight: '54px',
  border: `1px solid ${theme.palette.grey[900]}`,
  borderRadius: '4px',
  textAlign: 'center',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  '&:hover': {
    background: 'white',
  },
  '&:disabled': {
    opacity: .5
  }
}));

export const TipLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '16px',
  lineHeight: '18px',
  margin: theme.spacing(1, 0, 0, 0),
}));

export const TipValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '14px',
  lineHeight: '16px',
  margin: theme.spacing(0, 0, 1, 0),
}));

export const TipValueOtherBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
}));

//Coupons

export const CouponTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '16px',
  lineHeight: '20px',
  fontWeight: 600,
  marginBottom: theme.spacing(4),
  marginTop: theme.spacing(3),
  textAlign: 'left'
}));

export const CouponSubmitButton = styled(LoadingButton)(({ theme }) => ({
  background: theme.palette.warning.main,
  borderTopRightRadius: '4px',
  borderBottomRightRadius: "4px",
  borderTopLeftRadius: '0px',
  borderBottomLeftRadius: '0px',
  color: 'white',
  boxShadow: 'none',
  zIndex: 999999,
  '&:hover': {
    backgroundColor: theme.palette.warning.main,
    boxShadow: 'none',
  },
  padding: theme.spacing(2),
  fontWeight: 600,
  fontSize: '14px',
}));

export const ApplyCouponWrapper = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[900]}`,
  borderRadius: '4px',
  minHeight: '56px',
  height: 'auto',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2, 2),
  textAlign: 'left',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  opacity: 1,
  overflow: 'hidden',
}));

export const ApplyCouponStartInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const ApplyCouponName = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '14px',
  lineHeight: '16px',
}));

export const ApplyCouponRemove = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '14px',
  lineHeight: '16px',
  textDecoration: 'underline',
  textTransform: 'inherit',
  '&:hover': {
    textDecoration: 'underline',
  }
}));

// Card Payment

export const FullModeWrapper = styled(Box)(({ theme }) => ({
  border: `1px solid rgba(61, 61, 61, 0.3)`,
  borderRadius: '4px',
  textAlign: 'left',
}));

export const FullModeInnerWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  // display: 'flex',
  // justifyContent: 'center',
  // alignItems: 'center',
  width: '100%',
}));

export const PaymentStyledRadioGroup = styled(RadioGroup)(() => ({
  '& label > span': {
    display: 'flex',
    alignItems: 'center',
  },
  '& label': {
    margin: 0,
  },
  width: '100%',
}));

export const PaymentStyledInner = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',    // Vertically centers the items
  justifyContent: 'center', // Horizontally centers the items
  gap: '12px',
  textAlign: 'center',
  paddingRight: '10px',
}));

export const PaymentStyledText = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: '16px',
  lineHeight: '18.75px',
}));

export const PaymentButton = styled(LoadingButton)(({ theme }) => ({
  color: 'white',
  minHeight: '48px',
  background: theme.palette.primary.main,
  fontSize: '16px',
  lineHeight: '18.75px',
  fontWeight: 600,
  width: '100%',
  borderRadius: '4px',
  cursor: 'pointer',
  marginTop: theme.spacing(1),
  padding: theme.spacing(1, 2),
  '&:disabled': {
    background: '#E7E7E7',
    cursor: 'not-allowed'
  },
  '&:hover': {
    borderRadius: '4px',
    padding: theme.spacing(1, 2),
    color: 'white',
    background: theme.palette.primary.main,
    cursor: 'pointer',
  }
}));

export const ThankYouTitle = styled(Typography)(({ theme }) => ({
  color: '#000000',
  fontSize: '22px',
  lineHeight: '28px',
  paddingBottom: theme.spacing(1)
}));

export const ThankYouPaidTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '14px',
  lineHeight: '20px',
  paddingBottom: theme.spacing(10)
}));


export const ThankYouCashTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '14px',
  lineHeight: '20px',
  paddingBottom: theme.spacing(10)
}));


export const OrderNumberTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '14px',
  paddingBottom: theme.spacing(0.5)
}));

export const ThankYouPaidContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minHeight: '100vh',
  '& > img': {
    width: '100px',
    height: '100px',
    textAlign: 'center',
    margin: '0 auto 70px',
  }
}));

export const LoaderBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minHeight: '100vh',
  textAlign: 'center',
  margin: '0 auto',
  alignItems: 'center',
}));

export const GooglePayButton = styled(Box)(() => ({
  position: 'absolute',
  top: '-1px',
  left: '-1px',
  background: '#E7E7E7',
  width: '100%',
  bottom: '0',
  padding: '10px',
  fontWeight: 600,
  border: 'none',
  zIndex: 2,
  borderRadius: '4px',
  height: '42px',
  color: '#888',
  cursor: 'not-allowed'
}));

export const HelperText = styled(Typography)(() => ({
  fontSize: '12px',
  color: 'red',
  textAlign: 'left'
}));

export const ChargesMain = styled(Box)(({ theme }) => ({
  margin: theme.spacing(1.5, 0)
}));

export const ChagresMainBlock = styled(Box)(({ theme }) => ({
  textAlign: 'left',
  display: 'flex',
  justifyContent: 'space-between',
  paddingBottom: theme.spacing(1)
}));

export const ChagresTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '16px',
  lineHeight: '20px',
  letterSpacing: '0.25px',
  fontWeight: 600,
}));

export const ChagresValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0.25px',
  fontWeight: 600,
}));

export const ChagresBalanceTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '20px',
  lineHeight: '20px',
  letterSpacing: '0.25px',
  fontWeight: 600,
}));

export const ChagresBalanceValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '20px',
  lineHeight: '20px',
  letterSpacing: '0.25px',
  fontWeight: 600,
}));